








import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import { MobileGetter } from 'frontend/types';

@Component({
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class OnboardingOverlay extends Vue {
  @Prop({ type: String, required: true })
  private firstChapterName!: string;

  private readonly isMobile!: MobileGetter;

  private modalStyles: { [key: string]: string } = {};
  private clonedElement: HTMLElement | null = null;
  private recommendedLesson: HTMLElement | null = null;

  mounted(): void {
    this.highlightFirstLesson();
    document.body.classList.add('no-scroll');
  }

  destroyed() {
    document.body.classList.remove('no-scroll');
  }

  private highlightFirstLesson(): void {
    const cloneElementAndPutItInFront = (originalElement: HTMLElement): HTMLElement => {
      const clonedElement = originalElement.cloneNode(true) as HTMLElement;
      const originalElementClientRect = originalElement.getBoundingClientRect();
      const clonedElementAndModalBottom = originalElementClientRect.bottom + 160;
      const isEnoughSpaceForModal = clonedElementAndModalBottom < window.innerHeight;
      let offset = 0;

      if (!isEnoughSpaceForModal) {
        offset = Math.abs(window.innerHeight - clonedElementAndModalBottom);
        window.scroll({ top: offset, behavior: 'smooth' });
      }

      clonedElement.style.position = 'fixed';
      clonedElement.style.top = `${originalElementClientRect.top - offset}px`;
      clonedElement.style.left = `${originalElementClientRect.x}px`;
      clonedElement.style.zIndex = '700';

      // Line must be removed because it should not appear in front of the overlay.
      const connectingLine = clonedElement.querySelector<HTMLElement>('.vertical-line');
      if (connectingLine) {
        connectingLine.style.display = 'none';
      }

      return clonedElement;
    };
    const positionModalBelowElement = (element: HTMLElement): void => {
      const elementClientRect = element.getBoundingClientRect();
      const horizontalOffset = 24;
      const verticalOffset = 20;

      if (this.isMobile(this.$mq)) {
        this.modalStyles = {
          left: '12px',
          top: `${elementClientRect.y + elementClientRect.height + verticalOffset}px`,
        };
      } else {
        const modalWidth = 480;

        this.modalStyles = {
          left: `${
            elementClientRect.x + (elementClientRect.width - modalWidth) / 2 - horizontalOffset
          }px`,
          top: `${elementClientRect.y + elementClientRect.height + verticalOffset}px`,
        };
      }
    };

    this.recommendedLesson = document.querySelector<HTMLElement>('.lesson.is-recommended');

    if (this.recommendedLesson) {
      this.clonedElement = cloneElementAndPutItInFront(this.recommendedLesson);
      document.body.appendChild(this.clonedElement);
      positionModalBelowElement(this.clonedElement);

      // The original element stays but it should not be visible, in that way the layout is not altered.
      this.recommendedLesson.style.visibility = 'hidden';
    } else {
      this.closeOverlay();
    }
  }

  private closeOverlay(): void {
    if (this.recommendedLesson) {
      this.recommendedLesson.style.visibility = 'unset';
    }
    if (this.clonedElement) {
      document.body.removeChild(this.clonedElement);
    }
    this.$emit('overlay-closed');
  }
}
